import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const SrDayOnMarketTick = ({ x, y, data, payload }) => {
  const entry = data[payload.index];

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor='end'
        fontFamily='Greycliff'
        fontSize='16px'
        fill='rgba(0, 0, 0, 0.4)'
      >
        {payload.value}
      </text>
      <text
        x={4}
        y={16}
        dy={16}
        textAnchor='end'
        fontFamily='Greycliff'
        fontSize='10px'
        fill='rgba(0, 0, 0, 0.4)'
      >
        {moment(entry.date).format('MMM D')}
      </text>
    </g>
  );
};

SrDayOnMarketTick.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  payload: PropTypes.object.isRequired,
};

SrDayOnMarketTick.displayName = 'SrDayOnMarketTick';

export default SrDayOnMarketTick;
